var GMapMarkers;

module.exports = GMapMarkers = function(googleMaps) {
  return {
    googleMaps: googleMaps,
    makeMarkers: function(markerData) {
      var i, icon, j, len, len1, locationMarker, marker, markerOptions, ref, results;
      this.markers = [];
      results = [];
      for (i = 0, len = markerData.length; i < len; i++) {
        marker = markerData[i];
        locationMarker = {
          currentIndex: 0,
          coloredMarkers: []
        };
        ref = marker.icons;
        for (j = 0, len1 = ref.length; j < len1; j++) {
          icon = ref[j];
          markerOptions = {
            position: new this.googleMaps.LatLng(marker.lat, marker.lng),
            icon: {
              url: icon.url,
              scaledSize: marker.size ? new this.googleMaps.Size(marker.size.width, marker.size.height) : void 0
            }
          };
          locationMarker.coloredMarkers.push({
            color: icon.color,
            dynamicMarker: new this.googleMaps.Marker(markerOptions)
          });
        }
        results.push(this.markers.push(locationMarker));
      }
      return results;
    },
    createBounds: function(markers) {
      var bounds, i, len, marker, ref;
      bounds = new this.googleMaps.LatLngBounds();
      ref = markers || [];
      for (i = 0, len = ref.length; i < len; i++) {
        marker = ref[i];
        bounds.extend(marker.getPosition());
      }
      return bounds;
    },
    connectMapToMarkers: function(map, markers) {
      var i, len, marker, results;
      results = [];
      for (i = 0, len = markers.length; i < len; i++) {
        marker = markers[i];
        results.push(marker.setMap(map));
      }
      return results;
    },
    addMarkersToMap: function(map) {
      var i, len, marker, ref;
      this.activeMarkers = [];
      ref = this.markers;
      for (i = 0, len = ref.length; i < len; i++) {
        marker = ref[i];
        this.activeMarkers.push(marker.coloredMarkers[0].dynamicMarker);
      }
      this.connectMapToMarkers(map, this.activeMarkers);
      if (this.activeMarkers.length > 1) {
        this.bounds = this.createBounds(this.activeMarkers);
        return map.fitBounds(this.bounds);
      }
    }
  };
};

//# sourceMappingURL=data:application/json;base64,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
